

import React from "react";
import { Container, Row, Col } from 'react-bootstrap'
import AdminProfile from '../../Components/Admin/AdminProfile';
import SideBar from "../../Components/Admin/SideBar";



const AdminProfilePage = () => {
    return (

        <AdminProfile />
    )

}

export default AdminProfilePage

